/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrderSalesTotal model module.
 * @module model/OrderSalesTotal
 * @version v1
 */
class OrderSalesTotal {
    /**
     * Constructs a new <code>OrderSalesTotal</code>.
     * @alias module:model/OrderSalesTotal
     * @param startDate {String} Format [yyyy-MM-dd HH:mm:ss] UTC
     * @param endDate {String} Format [yyyy-MM-dd HH:mm:ss] UTC
     * @param totalValue {Number} 
     */
    constructor(startDate, endDate, totalValue) { 
        
        OrderSalesTotal.initialize(this, startDate, endDate, totalValue);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, startDate, endDate, totalValue) { 
        obj['StartDate'] = startDate;
        obj['EndDate'] = endDate;
        obj['TotalValue'] = totalValue;
    }

    /**
     * Constructs a <code>OrderSalesTotal</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderSalesTotal} obj Optional instance to populate.
     * @return {module:model/OrderSalesTotal} The populated <code>OrderSalesTotal</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderSalesTotal();

            if (data.hasOwnProperty('StartDate')) {
                obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'String');
            }
            if (data.hasOwnProperty('EndDate')) {
                obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'String');
            }
            if (data.hasOwnProperty('TotalValue')) {
                obj['TotalValue'] = ApiClient.convertToType(data['TotalValue'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OrderSalesTotal</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OrderSalesTotal</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of OrderSalesTotal.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['StartDate'] && !(typeof data['StartDate'] === 'string' || data['StartDate'] instanceof String)) {
            throw new Error("Expected the field `StartDate` to be a primitive type in the JSON string but got " + data['StartDate']);
        }
        // ensure the json data is a string
        if (data['EndDate'] && !(typeof data['EndDate'] === 'string' || data['EndDate'] instanceof String)) {
            throw new Error("Expected the field `EndDate` to be a primitive type in the JSON string but got " + data['EndDate']);
        }

        return true;
    }


}

OrderSalesTotal.RequiredProperties = ["StartDate", "EndDate", "TotalValue"];

/**
 * Format [yyyy-MM-dd HH:mm:ss] UTC
 * @member {String} StartDate
 */
OrderSalesTotal.prototype['StartDate'] = undefined;

/**
 * Format [yyyy-MM-dd HH:mm:ss] UTC
 * @member {String} EndDate
 */
OrderSalesTotal.prototype['EndDate'] = undefined;

/**
 * @member {Number} TotalValue
 */
OrderSalesTotal.prototype['TotalValue'] = undefined;






export default OrderSalesTotal;

